import styles from '@styles/components/Image.module.css'; // Assuming you store your CSS here
import { useEffect, useState } from 'react';

const Image = ({ src, alt, style, isRound = false, overrideLoading = undefined, defaultSrc = '/assets/Q.png'}) => {
    const [isImageLoading, setIsImageLoading] = useState(true);

    useEffect(() => {
        if (overrideLoading !== undefined) {
            setIsImageLoading(overrideLoading); // Assuming true means loaded
        }
    }, [overrideLoading]);

    return (
        <div className={styles['image-container']} style={{ ...style, position: 'relative', borderRadius: isRound ? '50%' : "0%"}}>
            {isImageLoading && <div className={styles['skeleton']} style={{ ...style, borderRadius: isRound ? '50%' : "0%"}}></div>}
            <img
                src={src && src !== "" ? src : defaultSrc}
                alt={alt}
                style={{ ...style, display: isImageLoading ? 'none' : 'block', borderRadius: isRound ? '50%' : "0%" }}
                onLoad={() => setIsImageLoading(false)}
            />
        </div>
    );
};

export default Image;